<template>
  <div id="Konfigurator" @pinchin="pinchIn">
    <img ref="sizeReference" id="sizeReference" :src="require('@/assets/' + /*this.$store.state.activeProduct*/'base.png')" />    
    <v-stage id="konvaStage" ref="stage"
    @mousedown="handleStageMouseDown"
    @touchstart="handleStageMouseDown"
    :config="{
      width: stageWidth,
      height: stageHeight
    }">
      <v-layer>
        <v-group
          @mouseenter="setMouseCursor('pointer')"
          @mouseleave="setMouseCursor('default')"
          @touchstart="imageTouchStart = performance.now()"
          @mousedown="imageTouchStart = performance.now()"
          @tap="performance.now() - imageTouchStart < 200 ? $refs.upload.click() : () => {}"
          @click="performance.now() - imageTouchStart < 200 ? $refs.upload.click() : () => {}"
          @pinchin="pinchIn"

          :config="{
            x: stageWidth * 0.323,
            y: stageHeight * 0.38,
            /*
            clipFunc: (ctx) => {
              ctx.ellipse(1, -5, stageWidth * 0.25, stageHeight * 0.235, 0, 0, 2 * Math.PI);
            }
            */
          }">
          <input ref="upload" style="display: none;" type="file" accept="image/*" v-on:change="changeImage($event.target.files); $event.target.value = ''" />
          <v-group v-if="!image">
            <v-circle :config="{
              radius: stageWidth * 0.20,
              fill: secondaryColor
            }" />
            <v-text ref="imageUploadIcon" :config="{
              text: '+',
              fill: primaryColor,
              fontSize: stageHeight * 0.05,
              offsetY: stageHeight * 0.03,
              offsetX: stageWidth * 0.02,
              align: 'center',
              verticalAlign: 'middle'
            }" />
            <v-text ref="imageUploadText" :config="{
              text: 'Bild hinzufügen',
              fill: primaryColor,
              offsetY: stageHeight * -0.02,
              offsetX: $refs.imageUploadText ? $refs.imageUploadText.getNode().width() / 2 : 42
            }" />
          </v-group>
          
        
        <v-group v-else>
          <v-image @dragstart="drag = true" @dragend="updateMenu(); drag = false" ref="image" :config="{
            width: (stageWidth * 0.30) * imageWidth,
            height: ((stageWidth * 0.30) * (image.height / image.width)) * imageHeight,
            x: imageX * stageWidth - 0.15 * stageWidth,
            y: imageY * stageHeight - 0.137 * stageHeight,
            image: resizedImage,
            draggable: true
          }" />
        </v-group>

        </v-group>
        <v-image v-if="showDesign" :config="{
          width: stageWidth,
          height: stageHeight,
          x: 0,
          y: 0,
          image: designTemplate,
          listening: false
        }" />

        <v-transformer ref="transformer" @transformStart="drag = true" @transformEnd="updateMenu(); drag = false" :config="{
          enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right']
        }" />
        <v-group 
          :config="{
            x: stageWidth * 0.66,
            y: stageHeight * 0.2,
          }" >
         <v-text ref="textBox" :config="{
            text: 'Dein Text',
            x: 0,
            y: 0,
            width: stageWidth * 0.28,
            height: stageHeight * 0.3,
            fontSize: stageHeight * fontSize,
            fontFamily: fontFamily,
            fill:color,
            
          }" @dblclick="textEditClick" @touchstart="textEditClick"
            />
        </v-group>
      </v-layer>
      
    </v-stage>
    <select
      @change="text2Store();"
       label="Schriftart"
       v-model="fontFamily"
       id="fontSelect" 
       :style="{fontFamily:fontFamily}"   
      >
    <option v-for="font in fonts" :key="font" :value="font" :style="{fontFamily:font}">{{font}}</option>
    </select>
    <Compact
        @input="color = $event.hex; text2Store();"
        :value="color"
        :palette="presetColors"
        :disableAlpha="true"
        id="colorPicker"
      ></Compact>
    <div v-if="selectedShape && !drag" :style="{
      top: (menuTop > 0 ? menuTop : 0) + 'px',
      left: (menuLeft > 0 ? menuLeft : 0) + 'px'
    }" id="menu">
      <div @click="$refs.upload.click()">Ändern</div>
      <div @click="image = null; selectedShape = null; $refs.transformer.getNode().detach()">Löschen</div>
    </div>   
  </div>
  
</template>

<script>

import { Compact, Material } from 'vue-color'

export default {
    components: {    
    'Compact': Compact,
    'Material': Material
  },
  data: function () {
    return {
      console: window.console,
      performance: window.performance,
      showDesign: true,
      stageWidth: 700,
      stageRatio: 1.071,
      cursor: 'default',
      image: null,
      selectedShape: null,
      scaleX:1,
      scaleY:1,
      imageX: 0,
      imageY: 0,
      imageXVal: 0,
      arrImgParameters: null,
      imageYVal: 0,
      imageWidth: 1,
      imageHeight: 1,
      primaryColor: '#f9ae1d',
      secondaryColor: '#f5f5f5',
      menuTop: 0,
      color: '#000000',
      menuLeft: 0,
      drag: false,
      fontSize: 0.03,
      fontFamily:"open sans",
      persText:'',
      fonts: [
        'open sans',
        'Roboto',
        'Satisfy',
        'Indie Flower'            
      ],
      presetColors: [
        'rgb(0,0,0)',
        'rgb(19,19,19)',
        'rgb(27,27,27)',
        'rgb(51,51,51)',
        'rgb(102,102,102)',
        'rgb(128,128,128)',           
        'rgb(255,255,0)',
        'rgb(255,190,0)',
        'rgb(255,127,2)',
        'rgb(254,65,2)',
        'rgb(255,0,0)',
        'rgb(190,0,64)',
        'rgb(128,0,128)',
        'rgb(86,48,141)',
        'rgb(43,97,156)',
        'rgb(24,135,105)',
        'rgb(2,168,55)',
        'rgb(129,212,27)',        
        'rgb(253,246,208)',        
        'rgb(191,129,158)',
        'rgb(183,179,202)',
        'rgb(180,199,220)',
        'rgb(176,202,199)',
        'rgb(176,206,146)',
        'rgb(232,242,161)',
        'rgb(255,255,109)',
        'rgb(255,221,89)',
        'rgb(254,150,46)',
        'rgb(250,130,88)',
        'rgb(255,109,109)',
        'rgb(225,97,115)',
        'rgb(161,70,126)',
        'rgb(142,134,174)',
        'rgb(225,159,207)',
        'rgb(127,171,162)',
        'rgb(119,190,103)',
        'rgb(106,83,156)',
        'rgb(89,129,176)',
        'rgb(82,150,140)',
        'rgb(77,180,73)',
        'rgb(188,226,61)',
        'rgb(231,233,2)',
        'rgb(226,169,12)',
        'rgb(219,118,0)',
        'rgb(242,73,0)',
        'rgb(244,11,13)',
        'rgb(169,7,77)',
        'rgb(120,2,116)',
        'rgb(88,41,129)',
        'rgb(54,99,166)',
        'rgb(18,128,84)',
        'rgb(5,152,46)',
        'rgb(97,185,26)',
        'rgb(172,178,12)',
        'rgb(176,125,0)',
        'rgb(184,83,0)',
        'rgb(186,78,24)',
        'rgb(201,33,30)',
        'rgb(133,17,65)',
        'rgb(101,9,83)',
        'rgb(85,33,90)',
        'rgb(53,82,105)',
  
      ]
    }
  },
  asyncComputed: {
    designTemplate () {

      return new Promise(resolve =>
        (async () => {
          let imageObj = new Image()

          await new Promise((resolve, reject) => {
            imageObj.onload = () => resolve(imageObj.height)
            imageObj.onerror = reject
            imageObj.src = require('@/assets/' + this.$store.state.activeProduct/*'base'*/+ '.png')
          })

          var canvas = document.createElement('canvas')
          canvas.width = this.stageWidth
          canvas.height = this.stageHeight
          var context = canvas.getContext('2d')
          context.drawImage(imageObj, 0, 0, this.stageWidth, this.stageHeight)

          resolve(canvas)
        })()
      )
    }
  },
  computed: {
    id: function () {
      return 0
    },
    stageHeight: function () {
      return this.stageWidth * this.stageRatio
    },
    resizedImage: function () {
      if (!this.image) {
        return null
      }

      var width = (this.stageWidth * 0.5) * (this.image.width / 1000)
      
      var height = width * (this.image.height / this.image.width)

      var canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height
      var context = canvas.getContext('2d')
      context.drawImage(this.image, 0, 0, width, height)

      return canvas
    }
  },
  beforeMount: function () {
    /*
    let imageObj = new Image()
    imageObj.onload = () => {
      this.designTemplate = imageObj.src
    }

    imageObj.src = require('@/assets/s4f_base.png')
    */
  },
  mounted: function () {
    this.fitStageIntoParentContainer()
    window.addEventListener('resize', this.fitStageIntoParentContainer)
    window.document.addEventListener('paste', this.onPaste)
    
    this.$store.dispatch('setKonvaStage', this.$refs.stage)
    window.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        this.moveImage([-1, 0])
      } else if (e.key === 'ArrowRight') {
        this.moveImage([1, 0])
      } else if (e.key === 'ArrowUp') {
        this.moveImage([0, -1])
      } else if (e.key === 'ArrowDown') {
        this.moveImage([0, 1])
      } else if (e.key === 'Add') {
        console.log('Add')
      } else if (e.key === 'a') {
        //console.log(this.$refs.image.getNode().attrs)
      }
    })
  },
  methods: {
    getText: function () {
      return this.persText
    },
  
    text2Store:function () {       
      this.$store.dispatch('setPersText', this.getText())
      this.$store.dispatch('setPersTextColor', this.color)
      this.$store.dispatch('setPersTextFont', this.fontFamily)
    },
    getVals:function() {

      //this.imageX=this.imageX+0.01
      //this.imageY=this.imageY+0.01
    },
     
    img2Store:function (val) {       
      this.$store.dispatch('setPersImg', val)
      //console.log("i2s r= "+this.rotateVal)
      //this.$store.dispatch('setPersImgParameters',this.rotateVal)
    },
        textEditClick: function (e) {
      this.drag = true
      var self=this;
      let textNode = e.target
      let layer = textNode.getLayer()
      let stageBox = textNode.getStage().container().getBoundingClientRect()

      textNode.hide()
      layer.draw()

      let textPosition = textNode.absolutePosition()
      let areaPosition = {
        x: stageBox.left + textPosition.x,
        y: stageBox.top + textPosition.y,
      };

      let textarea = document.createElement('textarea');
      document.body.appendChild(textarea)

      textarea.value = textNode.text();
      textarea.cols = '10';
      textarea.rows = '3';
      textarea.style.position = 'absolute';
      textarea.style.zIndex = '2';
      textarea.style.top = areaPosition.y + 'px';
      textarea.style.left = areaPosition.x + 'px';
      //textarea.style.width = textNode.width() - textNode.padding() * 2 + 'px';
      textarea.style.width = this.stageWidth * 0.27 + 'px';
      //textarea.style.height = textNode.height() - textNode.padding() * 2 + 5 + 'px';
      textarea.style.fontSize = textNode.fontSize() + 'px';
      textarea.style.border = 'none';
      textarea.style.padding = '0px';
      textarea.style.margin = '0px';
      textarea.style.overflow = 'hidden';
      textarea.style.background = 'none';
      textarea.style.outline = 'none';
      textarea.style.resize = 'none';
      textarea.style.lineHeight = textNode.lineHeight();
      textarea.style.fontFamily = textNode.fontFamily();
      textarea.style.transformOrigin = 'left top';
      textarea.style.textAlign = textNode.align();
      textarea.style.color = textNode.fill();
      let rotation = textNode.rotation();
      var transform = '';
      if (rotation) {
        transform += 'rotateZ(' + rotation + 'deg)';
      }

      var px = 0;
      // also we need to slightly move textarea on firefox
      // because it jumps a bit
      var isFirefox =
        navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
      if (isFirefox) {
        px += 2 + Math.round(textNode.fontSize() / 20);
      }
      transform += 'translateY(-' + px + 'px)';

      textarea.style.transform = transform;

      // reset height
      textarea.style.height = 'auto';
      // after browsers resized it we can set actual value
      textarea.style.height = textarea.scrollHeight + 3 + 'px';

      textarea.focus();

      function removeTextarea(e) {
        
        
        textarea.parentNode.removeChild(textarea);
        window.removeEventListener('click', handleOutsideClick);
        //window.removeEventListener('click', exfiltrateText);
        textNode.show();
        layer.draw();        
      }
      
      function exfiltrateText () {
        
        self.persText=textarea.value
        self.$store.persText=textarea.value
        
        self.text2Store();
       
      }   
    
      function setTextareaWidth(newWidth) {
        if (!newWidth) {
          // set width for placeholder
          newWidth = textNode.placeholder.length * textNode.fontSize();
        }
        // some extra fixes on different browsers
        var isSafari = /^((?!chrome|android).)*safari/i.test(
          navigator.userAgent
        );
        var isFirefox =
          navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        if (isSafari || isFirefox) {
          newWidth = Math.ceil(newWidth);
        }

        var isEdge =
          document.documentMode || /Edge/.test(navigator.userAgent);
        if (isEdge) {
          newWidth += 1;
        }
        textarea.style.width = newWidth + 'px';
      }

      textarea.addEventListener('keydown', function (e) {
        // hide on enter
        // but don't hide on shift + enter
        if (e.keyCode === 13 && !e.shiftKey) {
          textNode.text(textarea.value);
          
          removeTextarea();
        }
        // on esc do not set value back to node
        if (e.keyCode === 27) {
          removeTextarea();
        }
      });

      textarea.addEventListener('keydown', function (e) {
        let scale = textNode.getAbsoluteScale().x;
        setTextareaWidth(textNode.width() * scale);
        textarea.style.height = 'auto';
        
        textarea.scrollHeight + textNode.fontSize() + 'px';  
        self.persText = textarea.value;        
      });
     
      
      function handleOutsideClick() {
       
        if (e.target !== textarea) {
          exfiltrateText ();   
          textNode.text(textarea.value);       
          removeTextarea();  
                
        }
      }
     
      
      setTimeout(function() {
        window.addEventListener('click', handleOutsideClick);
        
      });
      
    },
    updateMenu: function () {
      this.menuTop = this.selectedShape.absolutePosition().y,
      this.menuLeft = (this.selectedShape.absolutePosition().x - 110),
      this.imageYVal = this.selectedShape.absolutePosition().y,
      this.imageXVal = this.selectedShape.absolutePosition().x,
      this.rotateVal= this.selectedShape.rotation(),
      this.scaleY = this.selectedShape.scaleY(),
      this.scaleX = this.selectedShape.scaleX(),
      this.imgWidth = this.selectedShape.width(),
      this.imgHeight = this.selectedShape.height()
      this.arrImgParameters ={
        "x":this.selectedShape.absolutePosition().x,
        "y":this.selectedShape.absolutePosition().y,
        "rotation": this.selectedShape.rotation(),
        "scaleX":this.selectedShape.scaleX(),
        "scaleY":this.selectedShape.scaleY(),
        "imageWidth": this.selectedShape.width(),
        "imageHeight": this.selectedShape.height(),     

      }
      //console.log(this.arrImgParameters)
      this.$store.dispatch('setPersImgParameters',this.arrImgParameters)
      
    },
    zoomImage: function (vector) {
      if (!this.image || !this.selectedShape) {
        return
      }
    },
    moveImage: function (vector) {
      if (!this.image || !this.selectedShape) {
        return
      }

      this.imageX = this.imageX + (0.01 * vector[0])
      this.imageY = this.imageY + (0.01 * vector[1])
    },
    pinchIn: function () {
      alert('pinchIn')
    },
    onPaste: function (event) {
      var items = (event.clipboardData || window.clipboardData || event.originalEvent.clipboardData).items;
      for (let i = 0; i < items.length; i++) {
        var item = items[i];
        if (item.kind === 'file') {
          this.changeImage([item.getAsFile()])
        } else if (item.kind === 'string') {
          var patt = /\.(png|jpg|svg|jpeg)$/g;
          item.getAsString((e) => {
            if (patt.test(e)) {
              this.changeImageData(e)
            }
          })
        }
      }
    },
    fitStageIntoParentContainer: function () {
      this.stageWidth = this.$refs.sizeReference.offsetWidth
    },
    setMouseCursor: function (newCursor) {
      this.cursor = newCursor
    },
    changeImage: function (image) {
      if (!image || !image[0]) {
        return
      }
      
      let reader = new FileReader()
      reader.readAsDataURL(image[0])

      reader.onloadend = () => {
        this.setMouseCursor('default')
        this.changeImageData(reader.result)
      }
    },
    changeImageData: function (imageSrc) {
      let imageObj = new Image()
      imageObj.onload = () => {
        this.image = imageObj
                
        this.$nextTick( () => {
          this.selectedShape = this.$refs.image.getNode()
          this.updateTransformer()
        })
      }      
      imageObj.src = imageSrc
      this.img2Store(imageSrc);
    },
    handleStageMouseDown(e) {
      // clicked on stage - clear selection
      if (e.target === e.target.getStage()) {
        this.selectedShape = null
        this.updateTransformer()
        return;
      }

      // clicked on transformer - do nothing
      if (e.target.getParent().className === 'Transformer') {
       
        return;
      }

      // find clicked rect by its name
      if (e.target.attrs.draggable) {
        
        this.selectedShape = e.target
        //this.rotateVal= e.target.rotation()
      } else {
        this.selectedShape = null
      }
      
      this.updateTransformer();
    },
    updateTransformer() {
      
      // here we need to manually attach or detach Transformer node
      const transformerNode = this.$refs.transformer.getNode();
      const stage = transformerNode.getStage();

      const selectedNode = this.selectedShape;
      // do nothing if selected node is already attached
      if (selectedNode === transformerNode.node()) {
        return;
      }

      if (selectedNode) {
        // attach to another node
        transformerNode.attachTo(selectedNode);
        this.updateMenu()
      } else {
        // remove transformer
        transformerNode.detach();
      }
      transformerNode.getLayer().batchDraw();
    }
  },
  watch: {
    cursor: function (val) {
      this.$refs.stage.getNode().container().style.cursor = val
    }
  }
}
</script>

<style lang="scss" scoped>
#Konfigurator {
  width: 700px;
  max-width: 80%;
  //margin: 0 auto;
  position: relative;

  #sizeReference {
    width: 100%;
  }

  #designTemplate {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    pointer-events: none;
  }

  #konvaStage {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
     #fontSelect {
    
    position: relative;
    margin-bottom: 5px;
    //top: 0;
    //left: 0;
    z-index: 998;
  
      @media only screen and (min-width: 768px) {
      position: absolute;
      }
    
  }
  #colorPicker {
    position:relative;
    z-index: 998;
    margin-bottom: 5px;
    box-shadow:none;
    //margin-left:50%;
    width:100%;
      @media only screen and (min-width: 768px) {
      position: absolute;
      display:inline-block;
      margin-top:4%;
      width:10%;
      }
  }
  #menu {
    width: 100px;
    position: absolute;
    z-index: 999;

    div {
      $height: 30px;
      height: $height;
      background-color: #EEE;
      border-bottom: 1px solid #666;
      text-align: center;
      line-height: $height;

      &:hover {
        cursor: pointer;
        background-color: #BBB;
      }
    }
  }
}
</style>
